<p-confirmDialog
  #cd
  styleClass="max-w-lg w-full mx-auto"
  appendTo="body"
  [attr.data-testid]="'confirmation-dialog'"
>
  <ng-template #footer>
    <div class="flex w-full gap-4">
      @if (cd.confirmation?.rejectVisible !== false) {
        <div class="w-1/2">
          <p-button
            severity="contrast"
            variant="outlined"
            [label]="'confirmationDialog.cancel' | transloco"
            (onClick)="cd.onReject()"
            styleClass="w-full"
          ></p-button>
        </div>
      }
      <div [class]="cd.confirmation?.rejectVisible === false ? 'w-full' : 'w-1/2'">
        <p-button
          [label]="'confirmationDialog.confirm' | transloco"
          (onClick)="cd.onAccept()"
          styleClass="w-full"
          [attr.data-testid]="'confirmation-dialog-accept-button'"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
